/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var FastQuoteState;

(function (FastQuoteState) {
  FastQuoteState["ACTIVE"] = "active";
  FastQuoteState["SYSTEM_GENERATED"] = "system_generated";
  FastQuoteState["MANUAL_QUICK_CALCULATE"] = "manual_quick_calculate";
  FastQuoteState["MANUAL_SWITCH_TO_JOVE"] = "manual_switch_to_jove";
  FastQuoteState["CMS_MANUAL_SWITCH_TO_JOVE"] = "cms_manual_switch_to_jove";
})(FastQuoteState || (FastQuoteState = {}));